/**
 * Barème de facturation PAR COMPTE — source unique de vérité (doctrine 4.20.0).
 *
 * Partagé entre le moteur serveur (`server/utils/account-billing.ts`, qui les
 * réexporte) et la communication tarifaire publique (home + /tarifs). Ne JAMAIS
 * réécrire ces montants en dur ailleurs : les importer depuis `#shared/account-pricing-constants`
 * (front) ou via la réexport de `account-billing.ts` (serveur).
 *
 * Le prix suit le NOMBRE d'hébergements, PAS leur type (CDH ou gîte).
 */

/** Ticket d'entrée annuel, 1er hébergement tout type (€). */
export const BASE_TICKET_EUR = 60
/** Incrément annuel par hébergement supplémentaire (€). */
export const EXTRA_ESTABLISHMENT_EUR = 10
/** Tarif réduit de la 2e année du privilège primo-adhérent / offre de lancement (€). */
export const PIONEER_YEAR2_EUR = 30
/**
 * Borne de la cohorte « Membre fondateur 2026 » (4.112.0), date Europe/Paris incluse.
 * Un compte dont la 1re publication est antérieure ou égale à cette date est fondateur :
 * tarif réduit (`PIONEER_YEAR2_EUR`) en 2e ET 3e année, puis plein tarif, et badge
 * permanent sur ses fiches. Le statut est figé sur `User.founderCohort` par migration —
 * cette constante sert à l'affichage et à la documentation, jamais à un recalcul.
 */
export const FOUNDER_CUTOFF_DATE = '2026-08-31'
